export const getDatestring = (date: string | Date, separator: string = "-", firstYear: boolean = true) => {
    let myDate: Date;
    if (typeof date === 'string') 
        myDate = new Date(date);
    else myDate = date
    const year = myDate.getFullYear();
    const monthNumber = myDate.getMonth() + 1;
    const month = `${monthNumber < 10 ? "0" : ""}${monthNumber}`;
    const dayNumber = myDate.getDate();
    const day = `${dayNumber < 10 ? "0" : ""}${dayNumber}`;
    if (firstYear) {
        return `${year}${separator}${month}${separator}${day}`
    }
    return `${day}${separator}${month}${separator}${year}`
}

const isValidDate = (date: any) => {
    return date instanceof Date && !isNaN(date.getTime());
}


export const formatDateToTimestamp = (date: string | null | Date) => {
    if (!date) {
        return date;
    }
    let myDate: Date;
    if (typeof date === 'string') 
        myDate = new Date(date);
    else myDate = date
    if (!isValidDate(myDate)) {
        return date;
    }
    const day = String(myDate.getDate()).padStart(2, '0');
    const month = String(myDate.getMonth() + 1).padStart(2, '0');
    const year = myDate.getFullYear();
    const hours = String(myDate.getHours()).padStart(2, '0');
    const minutes = String(myDate.getMinutes()).padStart(2, '0');

    const formattedDate = `${day}/${month}/${year} ${hours}:${minutes}`;
    return formattedDate;
}

export const getMonthName = (monthIndex: number) => {
    const months = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];
    return months[monthIndex];
};

export function getLocalISODate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}T00:00:00`;
}